import React from 'react';
import { connect } from 'react-redux';
import { Form, Input, message, Modal } from 'antd';
import * as actions from '../redux/actions/resetpassword';

class ResetPassword extends React.Component {
    state = {
        password: null,
        confirmLoading:false,
    }
    layout = {
        labelCol: {
            span: 12,
        },
        wrapperCol: {
            span: 12,
        },
    };
    tailLayout = {
        wrapperCol: {
            offset: 12,
            span: 16,
        },
    };
    handlePasswordChange = (e) => {
        this.setState(prevState => {
            return {
                ...prevState,
                password: e.target.value
            }
        })
    }
    onFinish = async (values) => {
        await this.props.onReset(this.props.resetId, this.state.password, this.props.token);
        this.setState(prevState=>{
            return {
                ...prevState,
                confirmLoading:true,
            }
        });
        setTimeout(()=>{
            this.setState(prevState=>{
                return {
                    ...prevState,
                    password:null,
                    confirmLoading:false,
                }
            });
            if (this.props.resetMessage) {
                message.success(this.props.resetMessage);
            }
            if (this.props.resetError) {
                message.error(this.props.resetError);
            }
            this.props.onCloseForm();
            this.props.onClear();
        },400)
    }
    onFinishFailed = (errorInfo) => {
        message.error('All inputs are required. Input correctly.');
    }
    handleCancel=()=>{
        this.props.onCloseForm();
    }
    render() {
        return (
            <Modal
                title="Reset User Password"
                key={this.props.resetId}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'reset-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.state.confirmLoading}
                onCancel={this.handleCancel}
                okText="Save"
            >
                <Form
                    style={{ margin: 25 }}
                    id="reset-form"
                    {...this.layout}
                    name="basic"
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="password"
                        label="New Password"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your password!',
                            },
                            { min: 6, message: 'Minimum 6 characters.' },
                        ]}
                        hasFeedback
                    >
                        <Input.Password onChange={this.handlePasswordChange} allowClear/>
                    </Form.Item>

                    <Form.Item
                        name="confirm"
                        label="Confirm New Password"
                        dependencies={['password']}
                        hasFeedback
                        rules={[
                            {
                                required: true,
                                message: 'Please confirm your password!',
                            },
                            ({ getFieldValue }) => ({
                                validator(rule, value) {
                                    if (!value || getFieldValue('password') === value) {
                                        return Promise.resolve();
                                    }

                                    return Promise.reject('Passwords do not match!');
                                },
                            }),
                        ]}
                    >
                        <Input.Password allowClear/>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}
const mapStateToProps = state => {
    return {
        token: state.auth.token,
        resetMessage: state.resetPassword.message,
        resetError: state.resetPassword.error,
        visible: state.resetPassword.visibleResetForm,
        resetId: state.resetPassword.resetId,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onCloseForm: () => dispatch(actions.closeResetForm()),
        onReset: (id, password, token) => dispatch(actions.resetPassword(id, password, token)),
        onClear: () => dispatch(actions.clearReset()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);